export const PENDO_API_KEY = "a5477186-b8da-410b-a703-67a74e350a9f";

/**
 * List of country codes (ISO 3166-1 alpha-2) where Pendo is approved to run
 * in production. Add country codes here as Pendo is rolled out to more markets.
 */
export const PENDO_APPROVED_COUNTRIES: string[] = [
  "BE",
  "CA",
  "CZ",
  "DK",
  "FI",
  "HU",
  "JP",
  "SK",
  "US",
];
